import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

function getSnapshot() {
  const ua = navigator.userAgent;
  if (/EquityLabs-Tauri/.test(ua)) return false;
  return /Mac/.test(ua) && !/iPhone|iPad|iPod|Android/i.test(ua);
}

const getServerSnapshot = () => false;

export function useIsMacDesktop() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
